import { cn } from 'components/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const TranscriptIndicator = ({
  isRecording,
}: {
  isRecording: boolean;
}) => {
  const { t } = useTranslation();
  const [minimize, setMinimize] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setMinimize(false);
    }, 150);

    setTimeout(() => {
      setMinimize(true);
    }, 5000);
  }, []);

  if (!isRecording) {
    return null;
  }

  return (
    <div
      className={cn(
        `flex flex-row bg-negative text-white items-center px-3 py-2 rounded-lg transform transition-all ease-linear duration-150 max-h-8 overflow-hidden cursor-default`,
        {
          'max-w-8 w-8': minimize,
          'max-w-48 w-[184px]': !minimize,
        }
      )}
      onMouseEnter={() => setMinimize(false)}
      onMouseLeave={() => setMinimize(true)}
    >
      <div className="shrink-0 rounded-full w-2 h-2 bg-white animate-pulse" />
      <span
        className={cn(
          'transform transition-all whitespace-nowrap ease-linear duration-200',
          {
            'opacity-0 w-0': minimize,
            'opacity-100 w-44 ml-2': !minimize,
          }
        )}
      >
        {t('videocall__transcript_banner_text')}
      </span>
    </div>
  );
};
